import { render, staticRenderFns } from "./NeoNumberChange.vue?vue&type=template&id=21e73556&scoped=true&lang=pug"
import script from "./NeoNumberChange.vue?vue&type=script&lang=js"
export * from "./NeoNumberChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e73556",
  null
  
)

export default component.exports